import { render, staticRenderFns } from "./LeftMenuItem.vue?vue&type=template&id=543f4058&"
import script from "./LeftMenuItem.vue?vue&type=script&lang=js&"
export * from "./LeftMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports